import clsx from 'clsx';
import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import './button.scss';

interface ButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  isBlock?: boolean;
  isLoading?: boolean;
  variant?: 'primary' | 'danger' | 'secondary' | 'tertiary' | 'danger-light';
  isRound?: boolean;
  size?: 'small' | 'large';
  hasSkeleton?: boolean;
}

export function Button({
  isBlock,
  className,
  isLoading,
  variant = 'primary',
  isRound,
  size = 'large',
  children,
  hasSkeleton,
  ...restProps
}: ButtonProps): ReactElement {
  return (
    <button
      className={clsx(
        'button',
        isBlock && 'button-block',
        isRound && 'button-round',
        size && `button-${size}`,
        variant && `button-${variant}`,
        isLoading && 'loading',
        className
      )}
      {...restProps}>
      {hasSkeleton ? <Skeleton className='button-skeleton' /> : children}
    </button>
  );
}
